
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class ViewPlayer extends Vue {
    playing = false
    mutes = false
    currentTime = 0
    duration = 0
    private timeUpdateHandler: (() => void) | null = null
    private loadedMetadataHandler: (() => void) | null = null
    clickTo() {
        if (!this.current) {
            return
        }
        this.$store.commit('showFullFalse');
        this.$router.push('/album/'+this.current.album_id)
    }
    get current (){
        return this.$store.getters['getCurrent']
    }
    get audio () {
        return this.$store.getters['getAudio']
    }
    get isShuffle () {
        return this.$store.getters['getShuffle']
    }
    get isRepeat () {
        return this.$store.getters['getRepeat']
    }
    get isRadio () {
        return this.$store.getters['getRadio']
    }
    mute () {
        this.audio.muted = !this.audio.muted
        this.mutes = !this.mutes
    }
    async toggleRadio() {
        this.$store.commit('setRadio')
        if (!this.isRadio) {
            return
        }
        if (this.current) {
            return
        }
        const track = await this.$store.dispatch('startRadioPlayback')
        if (track) {
            this.audio.play()
            this.playing = false
        }
    }
    shuffle() {
        this.$store.commit('setShuffle')
    }
    repeat() {
        this.$store.commit('setRepeat')
    }
    play () {
        if (!this.current) {
            return
        }
        this.audio.play()
        this.playing = !this.playing
    }
    pause () {
        if (!this.current) {
            return
        }
        this.audio.pause()
        this.playing = !this.playing
    }
    convertTime (secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }
    get formattedCurrentTime() {
        return this.convertTime(Math.round(this.currentTime))
    }
    get formattedDuration() {
        return this.convertTime(Math.round(this.duration))
    }
    seekTo(event: Event) {
        const input = event.target as HTMLInputElement
        this.audio.currentTime = parseFloat(input.value)
    }
    playNext () {
        if (!this.current) {
            return
        }
        this.$store.dispatch('playNextTrack').then((track) => {
            if (!track) {
                return
            }
            this.audio.play().catch(() => undefined)
        })
    }
    playPrevious () {
        if (!this.current) {
            return
        }
        this.$store.dispatch('playPreviousTrack').then((track) => {
            if (!track) {
                return
            }
            this.audio.play().catch(() => undefined)
        })
    }
    times = '00:00'

    mounted () {
        this.timeUpdateHandler = () => {
            this.currentTime = this.audio.currentTime
            if (!isNaN(this.audio.duration)) {
                this.duration = this.audio.duration
            }
        }
        this.loadedMetadataHandler = () => {
            if (!isNaN(this.audio.duration)) {
                this.duration = this.audio.duration
            }
        }
        this.audio.addEventListener('timeupdate', this.timeUpdateHandler)
        this.audio.addEventListener('loadedmetadata', this.loadedMetadataHandler)
        // Init with current values
        this.currentTime = this.audio.currentTime
        if (!isNaN(this.audio.duration)) {
            this.duration = this.audio.duration
        }
    }

    beforeDestroy() {
        if (this.timeUpdateHandler) {
            this.audio.removeEventListener('timeupdate', this.timeUpdateHandler)
        }
        if (this.loadedMetadataHandler) {
            this.audio.removeEventListener('loadedmetadata', this.loadedMetadataHandler)
        }
    }
}
